var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('button',{class:{
        'square-button' : _vm.shape === 'square',
        'round-button' : _vm.shape === 'round',
        'round-button--anytime' : _vm.anytime === true,
        'square-button--sm square-button--danger': _vm.size == 'sm'
    },on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('button',{class:{
        'square-button square-button--disabled'  : _vm.shape === 'square',
        'round-button round-button--disabled'   : _vm.shape === 'round',
        'round-button--anytime' : _vm.anytime === true
    }},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }